import {
  IParticleShape,
  ParticleShapeData,
} from "./VolumetricParticles.interface";

export class BlockchainParticles implements IParticleShape {
  generate(count: number, size: number): ParticleShapeData {
    const positions = new Float32Array(count * 3);
    const types = new Float32Array(count);
    // Increased block size and adjusted gap to maintain stride of 0.7 * size (560 at size=800)
    // This matches the shader's period of 1680 (3 * 560)
    const blockSize = size * 0.5;
    const gap = size * 0.2;
    const numBlocks = 3;
    const totalWidth = numBlocks * blockSize + (numBlocks - 1) * gap;
    const startX = -totalWidth / 2 + blockSize / 2;

    for (let i = 0; i < count; i++) {
      const blockIdx = Math.floor(Math.random() * numBlocks);
      const centerX = startX + blockIdx * (blockSize + gap);

      // Determine if particle is inside (Gold) or surface (Blue)
      // 30% inside, 70% surface
      const isInside = Math.random() < 0.3;
      types[i] = isInside ? 1.0 : 0.0;

      if (isInside) {
        // Random inside
        positions[i * 3] = centerX + (Math.random() - 0.5) * blockSize;
        positions[i * 3 + 1] = (Math.random() - 0.5) * blockSize;
        positions[i * 3 + 2] = (Math.random() - 0.5) * blockSize;
      } else {
        // Surface
        // Pick face: 0=x+, 1=x-, 2=y+, 3=y-, 4=z+, 5=z-
        const face = Math.floor(Math.random() * 6);
        let x, y, z;
        const half = blockSize / 2;
        const rand = () => (Math.random() - 0.5) * blockSize;

        switch (face) {
          case 0:
            x = half;
            y = rand();
            z = rand();
            break;
          case 1:
            x = -half;
            y = rand();
            z = rand();
            break;
          case 2:
            x = rand();
            y = half;
            z = rand();
            break;
          case 3:
            x = rand();
            y = -half;
            z = rand();
            break;
          case 4:
            x = rand();
            y = rand();
            z = half;
            break;
          case 5:
            x = rand();
            y = rand();
            z = -half;
            break;
          default:
            x = 0;
            y = 0;
            z = 0;
        }
        positions[i * 3] = centerX + x;
        positions[i * 3 + 1] = y;
        positions[i * 3 + 2] = z;
      }
    }
    return { positions, extraAttributes: { types } };
  }
}
